import { useCallback, useState } from 'react';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import {
  RadioFilterValue,
  RADIO_FILTER_VALUE_MAP,
  RADIO_FILTER_VALUE_REVERSE_MAP,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants/radioFilters';

const CALLABLE_OPTIONS = [
  { value: RadioFilterValue.Include, label: 'Include callable' },
  { value: RadioFilterValue.Exclude, label: 'Exclude callable' },
  { value: RadioFilterValue.Only, label: 'Callable Only' },
];

const useCallableFilter = () => {
  const { localFilters, setLocalFilters } = useCorporateBondScreenerSidebarFilterContext();
  const [selectedValue, setSelectedValue] = useState(
    () => RADIO_FILTER_VALUE_REVERSE_MAP.get(localFilters.callable) ?? RadioFilterValue.Include,
  );

  const onChange = useCallback((value: string): void => {
    setSelectedValue(value);
    setLocalFilters((prev) => ({ ...prev, callable: RADIO_FILTER_VALUE_MAP[value] }));
  }, [setLocalFilters]);

  return { selectedValue, onChange, options: CALLABLE_OPTIONS };
};

export default useCallableFilter;
